import { DEBUG_STATUS, DEFAULT_STATUS } from '../constants/initialization';

/**
 * @param {boolean} useDebug
 * @return {string[]}
 */
export const getAvailableStatuses = (useDebug = false) => {
  return useDebug ? [DEFAULT_STATUS, DEBUG_STATUS] : [DEFAULT_STATUS];
};

/**
 * @param {Function} fn
 * @return {function(...[*]=): *}
 */
export const getListWithStatus = (fn) => {
  return (args, useDebug = false) => {
    const availableStatuses = getAvailableStatuses(useDebug);

    return fn
      .call(null, args)
      .filter(({ status }) => availableStatuses.includes(status.toUpperCase()));
  };
};
